import React from 'react';
import { Link } from 'react-router-dom';

export default function AdminHome() {
  return (
    <div className="admin-page">
      <div className="admin-page-header">
        <div>
          <h2>Ringkasan Cepat</h2>
          <p className="text-muted-small">
            Akses cepat untuk menambah konten dan mengelola halaman.
          </p>
        </div>
      </div>

      <div className="admin-quick-actions">
        <Link to="/admin/post/new" className="quick-action-card">
          <i className="bi bi-plus-circle"></i>
          Buat Artikel
        </Link>
        <Link to="/admin/post" className="quick-action-card">
          <i className="bi bi-journal-richtext"></i>
          Kelola Artikel
        </Link>
        <Link to="/admin/testimonials" className="quick-action-card">
          <i className="bi bi-chat-quote"></i>
          Kelola Testimoni
        </Link>
        <Link to="/admin/stories" className="quick-action-card">
          <i className="bi bi-chat-dots"></i>
          Kelola Cerita
        </Link>
        <Link to="/admin/settings" className="quick-action-card">
          <i className="bi bi-gear"></i>
          Pengaturan Admin
        </Link>
      </div>

      <div className="admin-card">
        <h3>Tips Pengelolaan</h3>
        <p className="text-muted-small mb-2">
          Pastikan artikel memiliki gambar utama, excerpt singkat, dan status terbit agar tampil di landing page.
        </p>
        <p className="text-muted-small mb-0">
          Testimoni terbaik adalah yang ringkas, autentik, dan mencerminkan pengalaman pasien.
        </p>
      </div>
    </div>
  );
}
